import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import RadioGroup from '../../common/RadioGroup';
// import RadioGroup from '../../common/RadioGroup';

const RadioGroupComponent = () => {
    const options1 = [
        { value: 'option1', label: 'Option 1' },
        { value: 'option2', label: 'Option 2' },
        { value: 'option3', label: 'Option 3' }
    ];
    const options2 = [
        { value: 'apple', label: 'Apple' },
        { value: 'banana', label: 'Banana' },
        { value: 'cherry', label: 'Cherry' },
        { value: 'date', label: 'Date' }
    ];
    const options3 = [
        { value: 'js', label: 'JavaScript' },
        { value: 'python', label: 'Python' },
        { value: 'java', label: 'Java' },
        { value: 'cpp', label: 'C++' },
        { value: 'ruby', label: 'Ruby' }
    ];

    const handleSelectionChange = (selectedOption) => {
        console.log('Selected Option:', selectedOption);
    };

    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Radio Group Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RadioGroup
                                    label="Choose an Option"
                                    options={options1}
                                    required={true}
                                    onChange={handleSelectionChange}
                                    showHelp={true}
                                    helpText="Please select one option."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RadioGroup
    label="Choose an Option"
    options={[
        { value: 'option1', label: 'Option 1' },
        { value: 'option2', label: 'Option 2' },
        { value: 'option3', label: 'Option 3' }
    ]}
    required={true}
    onChange={handleSelectionChange}
    showHelp={true}
    helpText="Please select one option."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RadioGroup
                                    label="Pick a Fruit"
                                    options={options2}
                                    required={false}
                                    defaultSelected="banana"
                                    onChange={handleSelectionChange}
                                    showHelp={true}
                                    helpText="Pick one fruit."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RadioGroup
    label="Pick a Fruit"
    options={[
        { value: 'apple', label: 'Apple' },
        { value: 'banana', label: 'Banana' },
        { value: 'cherry', label: 'Cherry' },
        { value: 'date', label: 'Date' }
    ]}
    required={false}
    defaultSelected="banana"
    onChange={handleSelectionChange}
    showHelp={true}
    helpText="Pick one fruit."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RadioGroup
                                    label="Select a Programming Language"
                                    options={options3}
                                    required={true}
                                    onChange={handleSelectionChange}
                                    customError="Please choose a programming language."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RadioGroup
    label="Select a Programming Language"
    options={[
        { value: 'js', label: 'JavaScript' },
        { value: 'python', label: 'Python' },
        { value: 'java', label: 'Java' },
        { value: 'cpp', label: 'C++' },
        { value: 'ruby', label: 'Ruby' }
    ]}
    required={true}
    onChange={handleSelectionChange}
    customError="Please choose a programming language."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RadioGroup
                                    label="Agree to a Policy"
                                    options={[
                                        { value: 'agree_terms', label: 'I agree to the terms' },
                                        { value: 'agree_privacy', label: 'I agree to the privacy policy' }
                                    ]}
                                    required={true}
                                    onChange={handleSelectionChange}
                                    layout="inline"
                                    showHelp={true}
                                    helpText="You must agree to the policies."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RadioGroup
    label="Agree to a Policy"
    options={[
        { value: 'agree_terms', label: 'I agree to the terms' },
        { value: 'agree_privacy', label: 'I agree to the privacy policy' }
    ]}
    required={true}
    onChange={handleSelectionChange}
    layout="inline"
    showHelp={true}
    helpText="You must agree to the policies."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default RadioGroupComponent;
